import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#1a1a1a',
        color: 'white',
        pt: 8,
      }}
    >
      <Container maxWidth="lg">
        {/* Signature */}
        <Box
          sx={{
            textAlign: 'center',
            mb: 6,
          }}
        >
          <img
            src="/signature.svg"
            alt="Kevyn Signature"
            width="200"
            height="60"
            loading="lazy"
            style={{
              height: '60px',
              width: 'auto',
              filter: 'invert(1)',
            }}
            onError={(e: any) => {
              e.target.style.display = 'none';
              const parent = e.target.parentElement;
              parent.innerHTML = '<span style="font-family: cursive; font-size: 3rem; color: white;">Kevyn</span>';
            }}
          />
        </Box>

        {/* Footer Navigation */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: { xs: 2, md: 4 },
            mb: 4,
            pb: 4,
            borderBottom: '1px solid #333',
          }}
        >
          {[
            { label: 'SPEAKING ENGAGEMENTS', href: '/speaking' },
            { label: 'WRITING', href: '/articles' },
            { label: 'CONSULTING', href: '/consulting' },
            { label: 'PHILANTHROPY', href: '/philanthropy' },
          ].map((item, index) => (
            <Button
              key={index}
              component="a"
              href={item.href}
              sx={{
                color: 'white',
                fontWeight: 700,
                fontSize: { xs: '0.875rem', md: '1rem' },
                textDecoration: 'none',
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              {item.label}
            </Button>
          ))}
          <Button
            variant="outlined"
            component="a"
            href="mailto:kevyn@franco.expert"
            sx={{
              color: 'white',
              borderColor: '#dc143c',
              backgroundColor: '#dc143c',
              fontWeight: 700,
              fontSize: { xs: '0.875rem', md: '1rem' },
              px: 3,
              textDecoration: 'none',
              '&:hover': {
                backgroundColor: '#b01030',
                borderColor: '#b01030',
              },
            }}
          >
            Contact Me
          </Button>
        </Box>

        {/* Copyright */}
        <Box
          sx={{
            textAlign: 'center',
            py: 3,
          }}
        >
          <Typography
            sx={{
              color: '#666',
              fontSize: '0.875rem',
            }}
          >
            © {new Date().getFullYear()} Kevyn Franco. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
